import * as types from '../mutationTypes';

const state = {
  showDialog: false,
  message: null,
  onConfirm: null,
  onCancel: null,
  confirmOnly: false,
};

const actions = {
  showDialog({ commit }, payload) {
    commit(types.SHOW_DIALOG, payload);
  },
  confirmDialog({ commit, state }) {
    if (state.onConfirm) {
      state.onConfirm();
    }
    commit(types.HIDE_DIALOG);
  },
  cancelDialog({ commit, state }) {
    if (state.onCancel) {
      state.onCancel();
    }
    commit(types.HIDE_DIALOG);
  },
};

const mutations = {
  [types.SHOW_DIALOG](state, payload) {
    state.showDialog = true;
    state.message = payload.message;
    state.onConfirm = payload.onConfirm;
    state.onCancel = payload.onCancel;
    state.confirmOnly = payload.confirmOnly;
  },
  [types.HIDE_DIALOG](state) {
    state.showDialog = false;
    state.message = null;
    state.onConfirm = null;
    state.onCancel = null;
    state.confirmOnly = false;
  },
};

export const dialog = {
  namespaced: true,
  state,
  actions,
  mutations,
};
